document.addEventListener('DOMContentLoaded', function() {    
    class Form {
        constructor() {
            this.inputs = document.querySelectorAll("form.wpcf7-form input:not([type='file']), form textarea")
            this.events()
        }

        events() {
            this.inputs.forEach(el => {
                el.addEventListener("focus", this.doLabelMoveTop.bind(this))
                el.addEventListener("focusout", this.doLabelMoveTop.bind(this))
            })
        }

        doLabelMoveTop(e) {
            const theNode = e.target
            const theValue = e.target.value.trim()
            const theLabel = theNode.parentElement.nextElementSibling
            const theType = e.type

            if (theType === "focus") {
                theLabel.style.transform = "translateY(-1rem) scale(.9)"
                return
            }

            if (theType === "focusout" && theValue != "") return

            theLabel.style = null
        }
    }
    new Form()
})